import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Loader from '../../../../../../components/Loader';
import {connect} from "react-redux";
import {getNotificationCategories} from "src/actions/notifications.actions";


class NotificationCategories extends Component {

	state = {
		isToggled: false,
		isDisabled: false,
		isLoading: false,
		communicationPreferencesToggled: false,
		allCommunicationsToggled: null,
		notificationCategoriesState: [],
	};

	componentDidMount() {
		this.checkNotificationsToggled()
		this.setState({notificationCategoriesState: this.props.notificationCategoriesData})
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if(prevProps.notificationCategoriesData !== this.props.notificationCategoriesData) {

			this.setState({notificationCategoriesState: this.props.notificationCategoriesData}, () => this.checkNotificationsToggled())
		}
	}


	//checks if all communications toggle needs to be checked or not on load
	checkNotificationsToggled = () => {
		let optOutNotificationPresent = false;
		this.state.notificationCategoriesState.forEach((category) => {
			category.notificationPreferences.forEach((preference) => {
				if (preference.notificationType === 'EMAIL' && !preference.optedIn) {
					optOutNotificationPresent = true;
					this.setState({ allCommunicationsToggled: false });
					return;
				}
				if (preference.notificationType === 'TWILIOMSG' && !preference.optedIn) {
					optOutNotificationPresent = true;
					this.setState({ allCommunicationsToggled: false });
					return;
				}
			});
		});
		if (!optOutNotificationPresent) {
			this.setState({ allCommunicationsToggled: true });
		}
	};

	handleToggle = () => {
		this.setState((prevState) => ({
			isToggled: !prevState.isToggled
		}));
	};

	handleAllNotificationOptInOut = async () => {
		const lastToggleValue = this.state.allCommunicationsToggled;
		this.setState({ allCommunicationsToggled: !lastToggleValue });

		const newNotificationCategoriesState = this.state.notificationCategoriesState.map((category) => {
			const updatedPreferences = category.notificationPreferences.map((preference) => ({
				...preference,
				optedIn: !lastToggleValue,
			}));
			return { ...category, notificationPreferences: updatedPreferences };
		});

		this.setState({ notificationCategoriesState: newNotificationCategoriesState });

		this.props.notificationCategoriesData.forEach((notificationCategory) => {
			notificationCategory.notificationPreferences.forEach((preference) => {
				if (lastToggleValue) {
					this.props.handleNotificationUnsubscribe({
						notificationCategoryId: notificationCategory.id,
						type: preference.notificationType,
					});
				} else {
					this.props.handleNotificationSubscribe({
						notificationCategoryId: notificationCategory.id,
						type: preference.notificationType,
					});
				}
			});
		});

		await this.props.getNotificationCategories(this.props.accountId);
	};



	notificationOnClickHandler = (notificationCategory, type) => {
		let newNotificationCategory;
		const updatedPreferences = notificationCategory.notificationPreferences.map((preference) => {
			if (preference.notificationType === type) {
				return { ...preference, optedIn: !preference.optedIn };
			}
			return preference;
		});

		newNotificationCategory = { ...notificationCategory, notificationPreferences: updatedPreferences };

		const newCategoryState = this.state.notificationCategoriesState.map((notification) => {
			if (notification.id === newNotificationCategory.id) {
				return newNotificationCategory;
			}
			return notification;
		});

		this.setState({ notificationCategoriesState: newCategoryState }, () => this.checkNotificationsToggled());

		if (updatedPreferences.find((preference) => preference.notificationType === type).optedIn) {
			this.props.handleNotificationSubscribe({
				notificationCategoryId: notificationCategory.id,
				type: type,
			});
		} else {
			this.props.handleNotificationUnsubscribe({
				notificationCategoryId: notificationCategory.id,
				type: type,
			});
		}

		this.props.getNotificationCategories(this.props.accountId);
	};



	render() {
		const {
			isNotificationCategoriesLoaded,
			notificationCategoriesLoader
		} = this.props;

		const {
			communicationPreferencesToggled,
			allCommunicationsToggled,
			notificationCategoriesState,
			isLoading,
		} = this.state;

		if (!isNotificationCategoriesLoaded && notificationCategoriesLoader) {
			return <Loader />;
		}

		return (
			<div className="container-client-notifications-settings">
				<div className="card-toggable">
					<div className="card-toggable-header h-with-check">
          <span
						onClick={() => this.setState({communicationPreferencesToggled: !this.state.communicationPreferencesToggled})}
						className={communicationPreferencesToggled ? 'h-with-check-title toggled' : 'h-with-check-title'}
					>
            Communication Preferences
          </span>
					</div>
					<div style={{display: 'flex', flexDirection:'row', gap:'1vw', fontSize:'12px', lineHeight:'2px'}}>
						{communicationPreferencesToggled &&
							<>
								<span style={{paddingTop: '12px', paddingLeft: '25px'}}>All Communications</span>
								<div className="form-check checkbox-slider checkbox-slider--b-flat">
									<label>
										<input
											type="checkbox"
											checked={allCommunicationsToggled}
											onClick={() => {
												this.handleAllNotificationOptInOut()
											}}
										/>
										<span>&nbsp;</span>
									</label>
								</div>
							</>
						}
					</div>
					{communicationPreferencesToggled && allCommunicationsToggled === false &&
						<div style={{fontSize:'12px', marginTop:'2vh'}}>
							<div style={{display:'grid', gridTemplateColumns: '2fr 0.5fr 0.5fr'}}>
								<span>&nbsp;</span>
								<label>Email</label>
								<label>Text</label>
							</div>
							{notificationCategoriesState.map((notificationCategory) => {
								if (notificationCategory.notificationPreferences.length === 0) {
									return null;
								}
								return (
									<div style={{display:'grid', gridTemplateColumns: '2fr 0.5fr 0.5fr'}} key={notificationCategory.id}>
										<div>{notificationCategory.description}</div>
										{notificationCategory.notificationPreferences.some(preference => preference.notificationType === "EMAIL") &&
											<div className="form-check checkbox-slider checkbox-slider--b-flat">
												<label>
													<input
														type="checkbox"
														checked={notificationCategory.notificationPreferences.find(preference => preference.notificationType === "EMAIL").optedIn}
														onClick={() => {
															this.notificationOnClickHandler(notificationCategory, "EMAIL")
														}}
													/>
													<span>&nbsp;</span>
												</label>
											</div>
										}
										{notificationCategory.notificationPreferences.some(preference => preference.notificationType === "TWILIOMSG") &&
											<div className="form-check checkbox-slider checkbox-slider--b-flat">
												<label>
													<input
														type="checkbox"
														checked={notificationCategory.notificationPreferences.find(preference => preference.notificationType === "TWILIOMSG").optedIn}
														onClick={() => {
															this.notificationOnClickHandler(notificationCategory, "TWILIOMSG")
														}}
													/>
													<span>&nbsp;</span>
												</label>
											</div>
										}
									</div>
								);
							})}
						</div>
					}
				</div>
			</div>
		);
	}
}

NotificationCategories.propTypes = {
	notificationCategoriesData: PropTypes.array,
	notificationCategoriesLoader: PropTypes.bool,
	isNotificationCategoriesLoaded: PropTypes.bool,
	handleNotificationSubscribe: PropTypes.func,
	handleNotificationUnsubscribe: PropTypes.func,
};

NotificationCategories.defaultProps = {
	notificationCategoriesData: []
};



const mapDispatchToProps = {
	getNotificationCategories,
};

export default connect(null, mapDispatchToProps)(NotificationCategories);
